import { FaTrash } from 'react-icons/fa';

const BookmarkManager = ({ bookmarks, onDelete, onGoTo }) => {
    return (
        <div className="bookmark-manager">
            <h3>Marque-pages</h3>
            {bookmarks.length === 0 ? (
                <p>Aucun marque-page pour le moment.</p>
            ) : (
                <ul className="bookmark-list">
                    {bookmarks.map((bookmark) => (
                        <li key={bookmark._id} className="bookmark-item">
                            <div
                                className="bookmark-info"
                                onClick={() => onGoTo(bookmark.surahNumber, bookmark.ayahNumber)}
                                style={{ cursor: 'pointer' }}
                            >
                                <span className="bookmark-location">
                                    {bookmark.surahName || `Sourate ${bookmark.surahNumber}`} — Verset {bookmark.ayahNumber}
                                </span>
                                {bookmark.note && <p className="bookmark-note">{bookmark.note}</p>}
                            </div>
                            <div className="bookmark-actions">
                                <button
                                    className="btn-icon delete"
                                    onClick={() => onDelete(bookmark._id)}
                                    title="Supprimer le marque-page"
                                >
                                    <FaTrash />
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default BookmarkManager;
